import { Link } from "react-router-dom";
import { articles, hotArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = "http://cqxbygc.cn";

export default function Home() {
  const featuredArticles = articles.filter((a) => a.isTop || a.isHot).slice(0, 3);
  const latestArticles = articles.filter((a) => !a.isTop).slice(0, 6);

  const formatCount = (n: number) => {
    if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
    return n.toLocaleString();
  };

  return (
    <>
      {/* SEO Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "91吃瓜",
          url: SITE_URL,
          description:
            "91吃瓜社区今日黑料已送达，不打烊更新，沉浸式吃瓜快乐。",
          potentialAction: {
            "@type": "SearchAction",
            target: `${SITE_URL}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "91在线吃瓜 - 今日黑料大瓜新鲜出炉 | 91吃瓜网站高速入口",
          description:
            "还在找全网最真的瓜？91吃瓜社区今日黑料已送达。从热门91吃瓜大事件到网红圈席卷内幕，九一吃瓜网站为你盘点91吃瓜今日热议话题，不打烊更新。",
          url: SITE_URL,
          isPartOf: {
            "@type": "WebSite",
            name: "91吃瓜社区",
            url: SITE_URL,
          },
        })}
      </script>

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20news%20breaking%20concept%2C%20abstract%20digital%20network%20with%20glowing%20red%20and%20amber%20nodes%2C%20dark%20moody%20atmosphere%2C%20stylized%20artistic%20illustration%2C%20warm%20tones%2C%20news%20broadcast%20aesthetic%2C%20editorial%20composition&width=1600&height=900&seq=hero-main&orientation=landscape"
              alt="91吃瓜社区"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pt-20 pb-12 text-center">
            <h1
              className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              今日黑料
              <br />
              <span className="text-primary-400">新鲜出炉</span>
            </h1>
            <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
              全网最真的瓜，91吃瓜社区不打烊更新。
              <br className="hidden md:block" />
              从热门大事件到网红圈内幕，带你感受沉浸式吃瓜快乐。
            </p>
            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/wanghong"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                开始吃瓜
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
              >
                了解我们
              </Link>
            </div>
          </div>
        </section>

        {/* Hot Ranking + Featured */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Left: Featured Articles */}
            <div className="lg:col-span-2">
              <div className="flex items-center justify-between mb-5 md:mb-6">
                <div>
                  <h2
                    className="text-xl md:text-2xl font-bold text-foreground-950"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    推荐看点
                  </h2>
                  <p className="mt-1 text-sm text-foreground-500">精选今日最热爆料与深度话题</p>
                </div>
                <Link
                  to="/category/wanghong"
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
                >
                  查看更多
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} variant="featured" />
                ))}
              </div>
            </div>

            {/* Right: Hot Ranking */}
            <div className="lg:col-span-1">
              <div className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-4 md:mb-5">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className="ri-fire-line text-lg" />
                  </span>
                  <h3
                    className="text-lg font-bold text-foreground-950"
                    style={{ fontFamily: "var(--font-heading)" }}
                  >
                    热榜排行
                  </h3>
                </div>
                <div className="space-y-1">
                  {hotArticles.slice(0, 8).map((item) => (
                    <Link
                      key={item.rank}
                      to={`/article/${item.slug}`}
                      className="group flex items-start gap-3 py-2.5 px-2 rounded-lg hover:bg-background-100 transition-colors"
                    >
                      <span
                        className={`shrink-0 w-6 h-6 flex items-center justify-center rounded text-xs font-bold ${
                          item.rank <= 3
                            ? "bg-primary-500 text-white"
                            : "bg-background-200 text-foreground-500"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                          {item.title}
                        </p>
                        <div className="mt-0.5 flex items-center gap-2 text-xs text-foreground-500">
                          <span className="flex items-center gap-1">
                            <i className="ri-fire-line" />
                            {item.heat}°
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-eye-line" />
                            {formatCount(item.readCount)}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-3">
              分类浏览
            </span>
            <h2
              className="text-xl md:text-2xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              发现你感兴趣的瓜
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">
              六大热门分类，覆盖网红、娱乐、社会、情感、科技、搞笑，总有你想吃的瓜
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center text-center p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all"
              >
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-lg md:text-xl`} />
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {cat.articleCount} 篇文章
                </p>
              </Link>
            ))}
          </div>
        </section>

        {/* Latest Articles */}
        <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <h2
                className="text-xl md:text-2xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                最新吃瓜
              </h2>
              <p className="mt-1 text-sm text-foreground-500">每分钟更新，不错过任何新鲜爆料</p>
            </div>
            <Link
              to="/category/shehui"
              className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Main article list */}
            <div className="lg:col-span-2 space-y-3 md:space-y-4">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>

            {/* Sidebar */}
            <div className="lg:col-span-1 space-y-6">
              {/* Tags */}
              <div className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-950 mb-3">热门标签</h3>
                <div className="flex flex-wrap gap-2">
                  {["网红", "塌房", "分手", "翻车", "隐婚", "裁员", "直播", "爆料", "内幕", "争议"].map(
                    (tag) => (
                      <span
                        key={tag}
                        className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium hover:bg-secondary-200 transition-colors cursor-pointer"
                      >
                        {tag}
                      </span>
                    )
                  )}
                </div>
              </div>

              {/* Quick links */}
              <div className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-950 mb-3">快速入口</h3>
                <div className="space-y-2">
                  {[
                    { name: "今日热议", slug: "wanghong-tafang-quan-guocheng" },
                    { name: "深度爆料", slug: "dachang-youhua-mingdan-baoguang" },
                    { name: "正能量", slug: "waimai-xiaoge-jianyi-yongwei-quanwang" },
                    { name: "情感纠葛", slug: "wanghong-qinglv-fenshou-shuangfang-gezhi" },
                  ].map((link) => (
                    <Link
                      key={link.slug}
                      to={`/article/${link.slug}`}
                      className="flex items-center justify-between py-2 px-2 rounded-lg hover:bg-background-100 transition-colors group"
                    >
                      <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors">
                        {link.name}
                      </span>
                      <span className="w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors">
                        <i className="ri-arrow-right-s-line" />
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
